import { municipalFlatForm } from "modules/ebiForms/definitions/sharedHousing";
import { EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * E1. Przydział lokalu mieszkalnego z mieszkaniowego zasobu gminy (jednostka zarządzająca zasobem: ZBiLK, ZGM, ZBK) —
 * art. 20, art. 21 ust. 1 pkt 2 i art. 21b ustawy z 21.06.2001 r. o ochronie praw lokatorów, mieszkaniowym zasobie gminy
 * i o zmianie Kodeksu cywilnego; uchwała rady gminy. Ta sama procedura co A10 (urząd gminy): municipalFlatForm
 * w sharedHousing.ts — wzory Rudy Śląskiej (formularz 6.1 z zał. 1–3) i Gdańska, pobrane 22.10.2026; wzór Gminy Zalewo
 * (https://bip.zalewo.pl/system/obj/2671_Wniosek_o_przydzial_lokalu_komunalnego_lub_najmu_lokalu_socjalnego.pdf) — nie
 * pobrany (HTTP 403). Wywiad środowiskowy (art. 21b ust. 1c) zarządza gmina po złożeniu wniosku.
 */
const E1: IEbiFormDefinition = municipalFlatForm({
  code: "E1",
  office: EEbiFormOffice.MunicipalUnit,
  organ: "Wójt / Burmistrz / Prezydent Miasta — w jego imieniu jednostka zarządzająca mieszkaniowym zasobem gminy (np. ZBiLK, ZGM, ZBK)",
  title: "Wniosek o przydział lokalu mieszkalnego z mieszkaniowego zasobu gminy",
  description: "Przydział (najem) lokalu komunalnego lub socjalnego w jednostce zarządzającej zasobem gminy — z deklaracją o dochodach i oświadczeniami.",
  request: "Wnoszę o przydział lokalu z mieszkaniowego zasobu gminy w zakresie wskazanym we wniosku.",
});

export default E1;
